import io.ktor.client.HttpClientConfig
import io.ktor.client.engine.HttpClientEngineConfig
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.http.ContentType
import io.ktor.serialization.kotlinx.json.jsonIo
import kotlinx.serialization.json.Json

fun <T : HttpClientEngineConfig> HttpClientConfig<T>.setupGrIPClient() {
    install(ContentNegotiation) {
        jsonIo(gripJson, contentType = ContentType.Application.Json)
        jsonIo(gripJson, contentType = ContentType.Application.ProblemJson)
    }
}

val gripJson = Json {
    useAlternativeNames = false
    ignoreUnknownKeys = true
}
